// extracted by mini-css-extract-plugin
export default {"breakpointPostContentAreaMin":"746px","breakpointPostContentAreaSmall":"900px","container":"_557TX","loader":"zm-sc","loaderBubble":"_7nxe9"};